import { gql } from '@apollo/client';

export const intakesName = 'Intakes';
export const intakes = gql`
	fragment ${intakesName} on Member {
		intakes(condition: { completed: true }) {
			kind
			completed
		}
	}
`;
